import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {Subscription} from 'rxjs';
import {FacilitiesFormService} from '../../facilities-form/facilities-form.service';
import {FiringSystemDataObject} from '../../facilities-form/facilities-form.domain';

@Component({
  selector: 'app-releases',
  templateUrl: './releases.component.html',
  styleUrls: ['./releases.component.scss']
})
export class ReleasesComponent implements OnInit {
  @Input() firingSystemData: FiringSystemDataObject;
  @Input() isReadOnly: boolean = false;

  releasesFG: FormGroup;
  releasesCheckboxLabels: Array<any> = [];
  formSubscription: Subscription;

  constructor(private facilitiesFormService: FacilitiesFormService) {
    this.releasesCheckboxLabels = [
      {labelName: 'label-1', controlName: 'approvalClient'},
      {labelName: 'label-2', controlName: 'approvalPlanner'}];
  }

  prepareFormGroup() {
    this.releasesFG = new FormGroup({});
    this.formSubscription = this.releasesFG.valueChanges.subscribe((x) => {
      this.facilitiesFormService.registerForComponentFormUpdate.next({
        component: 'releases',
        formData: this.releasesFG,
      });
    });
  }

  ngOnInit(): void {
    this.prepareFormGroup();
    this.prepareCheckboxesFormControls();
    this.facilitiesFormService.registerForComponentFormUpdate.next({
      component: 'releases',
      formData: this.releasesFG,
    });
    this.facilitiesFormService.registerForActionOnFormSubmit.subscribe(
      (value: boolean) => {
        if (value) {
          this.resetData();
        }
      });
  }

  prepareCheckboxesFormControls() {
    this.releasesCheckboxLabels.forEach(value => {
      this.releasesFG.addControl(value.controlName,
        new FormControl(this.firingSystemData && this.firingSystemData[value.controlName] || ''));
    });
  }

  getCheckBoxLabel(label: string) {
    return `facilities-data.form-fields.releases-labels.${label}`;
  }

  private resetData(): void {
    this.formSubscription.unsubscribe();
    this.prepareFormGroup();
  }
}
